import React, { ReactElement } from 'react';

export interface Props {
    renderIf?: unknown;
    children: ReactElement[] | ReactElement;
}

const Optional = ({ children, renderIf }: Props): ReactElement | null => {
    if (renderIf) {
        return <>{children}</>;
    }
    return null;
};

export default Optional;
